import { Button as MuiButton, styled } from '@mui/material';

const Button = styled(MuiButton)`
  width: 240px;
  height: 60px;

  margin-top: 32px;

  font-size: 1.2rem;

  &:hover {
    transform: scale(1.02);
  }
`;

export default Button;
